export default {
    'ERROR-GET-CHALLENGES-ADMIN': {
        'GET-CHALLENGES-FAILED': {
            actionType: 'redirect',
            message: {
                fr: 'Impossible de récupérer les challenges.',
                en: 'Failed to retrieve challenges.',
            },
            redirectPath: '/',
        },
    },
    'ERROR-GET-AUDIENCE-ADMIN': {
        'GET-AUDIENCE-FAILED': {
            actionType: 'redirect',
            message: {
                fr: "Impossible de récupérer l’audience disponible.",
                en: 'Failed to retrieve available audience.',
            },
            redirectPath: '/',
        },
    },
    'ERROR-GET-CHALLENGE-ADMIN': {
        'GET-ONE-BY-ID-CHALLENGE-NOT-FOUND': {
            actionType: 'redirect',
            message: {
                fr: 'Challenge non trouvé.',
                en: 'Challenge not found.',
            },
            redirectPath: '/',
        },
    },
    'ERROR-CREATE-CHALLENGE-ADMIN': {
        'CREATE-ONE-CHALLENGE-MISSING-FIELDS': {
            actionType: 'toast',
            message: {
                fr: 'Des informations sont manquantes pour créer le challenge.',
                en: 'Missing information to create the challenge.',
            },
        },
    },
    'ERROR-UPDATE-CHALLENGE-ADMIN-GENERAL': {
        'UPDATE-ONE-CHALLENGE-NOT-FOUND': {
            actionType: 'redirect',
            message: {
                fr: 'Challenge non trouvé pour la mise à jour.',
                en: 'Challenge not found for update.',
            },
            redirectPath: '/',
        },
        'UPDATE-ONE-CHALLENGE-NOT-UPDATED': {
            actionType: 'toast',
            message: {
                fr: "La mise à jour des informations générales du challenge a échoué.",
                en: 'Failed to update the general information of the challenge.',
            },
        },
    },
    'ERROR-UPDATE-CHALLENGE-VALIDATION-ADMIN': {
        'UPDATE-ONE-CHALLENGE-NEED-PROOF-INVALID': {
            actionType: 'toast',
            message: {
                fr: 'Les preuves requises sont invalides pour la validation du challenge.',
                en: 'Required proofs are invalid for challenge validation.',
            },
        },
        'UPDATE-ONE-CHALLENGE-NEED-PROOF-DESCRIPTION-INVALID': {
            actionType: 'toast',
            message: {
                fr: 'La description des preuves est requise pour la validation.',
                en: 'Proof description is required for validation.',
            },
        },
        'UPDATE-ONE-CHALLENGE-NOT-FOUND': {
            actionType: 'redirect',
            message: {
                fr: 'Challenge non trouvé pour la mise à jour de validation.',
                en: 'Challenge not found for validation update.',
            },
            redirectPath: '/',
        },
        'UPDATE-ONE-CHALLENGE-NOT-UPDATED': {
            actionType: 'toast',
            message: {
                fr: "La mise à jour des informations de validation du challenge a échoué.",
                en: 'Failed to update challenge validation information.',
            },
        },
    },
    'ERROR-UPDATE-CHALLENGE-COMMUNICATION-ADMIN': {
        'UPDATE-ONE-CHALLENGE-NOT-FOUND': {
            actionType: 'redirect',
            message: {
                fr: 'Challenge non trouvé pour la mise à jour de communication.',
                en: 'Challenge not found for communication update.',
            },
            redirectPath: '/',
        },
        'UPDATE-ONE-CHALLENGE-NOT-UPDATED': {
            actionType: 'toast',
            message: {
                fr: "La mise à jour des informations de communication du challenge a échoué.",
                en: 'Failed to update challenge communication information.',
            },
        },
    },
    'ERROR-UPDATE-CHALLENGE-STATUS-ADMIN': {
        'CHANGE-STATUS-CHALLENGE-NOT-FOUND': {
            actionType: 'redirect',
            message: {
                fr: 'Challenge non trouvé pour la mise à jour du statut.',
                en: 'Challenge not found for status update.',
            },
            redirectPath: '/',
        },
        'CHANGE-STATUS-ALREADY-IN-STATUS': {
            actionType: 'toast',
            message: {
                fr: 'Le challenge est déjà dans ce statut.',
                en: 'The challenge is already in this status.',
            },
        },
        'CHANGE-STATUS-PUBLISHED-MISSING-FIELDS': {
            actionType: 'toast',
            message: {
                fr: 'Des champs obligatoires sont manquants pour publier le challenge.',
                en: 'Required fields are missing to publish the challenge.',
            },
        },
        'CHANGE-STATUS-SCHEDULED-MISSING-LAUNCH-DATE': {
            actionType: 'toast',
            message: {
                fr: 'La date de lancement est requise pour planifier le challenge.',
                en: 'Launch date is required to schedule the challenge.',
            },
        },
        'CHANGE-STATUS-INVALID-STATUS': {
            actionType: 'toast',
            message: {
                fr: 'Statut de challenge invalide.',
                en: 'Invalid challenge status.',
            },
        },
    },
    'ERROR-DUPLICATE-CHALLENGE-ADMIN': {
        'DUPLICATE-ONE-CHALLENGE-NOT-FOUND': {
            actionType: 'redirect',
            message: {
                fr: 'Challenge non trouvé pour la duplication.',
                en: 'Challenge not found for duplication.',
            },
            redirectPath: '/',
        },
    },
};
